import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=20386c88&"
import script from "./coupons.vue?vue&type=script&lang=js&"
export * from "./coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports